// 5. Activate subscription for the company
// https://api.skalebot.com/api/v1/support/subscription
// {    "companyId”:9,
//     "subscriptiontypeId":2
//     }

import { useState, useEffect,useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { CustomButton } from "../CustomButton";
import { classNames } from "primereact/utils";
import "./formStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { addSubscription,PlansDetails } from "../../reducers/customerSlice";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form"
import { isValidPhoneNumber } from 'react-phone-number-input'
import Loader from "../Loader";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";

function Subscription({onHide}) {
    const {selectedcustomers,mode}=useSelector((state) => state.customer)
    
        const defaultValues = {
            companyId:  selectedcustomers.companyId,
           subscriptiontypeId:""
        };
        const toast =useRef();
        const dispatch = useDispatch();
        const {
            control,
            formState: { errors },
            handleSubmit,
        } = useForm({ defaultValues });
        
        //function form get error message
        const getFormErrorMessage = (name) => {
            return (
            errors[name] && <small className="p-error">{errors[name].message}</small>
            );
        };
    
        const {loading,plans} = useSelector((state) => state.customer);
        useEffect(()=>{
            dispatch(PlansDetails())
        },[])
        
        const onSubmit=(data)=>{
            if(mode==='update'){
                toast.current.show({ severity: 'error', detail: "Update Not Enabled" });
              }else{
            dispatch(addSubscription({ data}))
            .unwrap()
            .then(res => {
                toastMessage("Company Added Succesfully")
                onHide();
            })
            .catch(err => {
             errorToastMessage(err.message)
            })
            }
        }
       const toastMessage=(msg)=>{
        toast.current.show({ severity: 'success', detail: msg });
       }
       const errorToastMessage=(msg)=>{
        toast.current.show({ severity: 'error', detail:  msg});
       }
        const modalLoad = () => {
            return <Loader visible={loading} />;
          };
    return (   
    <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
        {modalLoad()}
        <Toast ref={toast}/>
        <div className="field">
        <label htmlFor="companyId">Company  Id</label>
        <Controller
            name="companyId"
            control={control}
            rules={{ required: "companyID is required." }}
            render={({ field, fieldState }) => (
            <InputText
                id={field.name}
                maxLength={24}
                className={classNames({ "p-invalid": fieldState.invalid })}
                placeholder="Enter companyID here"
                {...field}
                disabled
            />
            )}
        />
        {getFormErrorMessage("companyID")}
        </div>
        <div className="field">
        <label htmlFor="subscriptiontypeId">Subscription Type *</label>
      
        <Controller
            name="subscriptiontypeId"
            control={control}
            rules={{ required: "subscriptiontypeId is required." }}
            render={({ field, fieldState }) => (
                <Dropdown
                id={field.name}
                optionLabel={`name`}
                optionValue={`id`}
                options={plans}
                maxLength={24}
                className={classNames({ "p-invalid": fieldState.invalid })}
                placeholder="Select a subscription Type"
                required
                {...field}
              />
            )}
        />
        {getFormErrorMessage("subscriptiontypeId")}
        </div>
       
        <div>
        <CustomButton
            varient="filled"
            type="submit"
            label={"Save"}
        />
            
        </div>
    </form> );
}

export default Subscription;